import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Sparkles, ArrowRight } from "lucide-react";
import { getList } from "@/lib/api";
import { getTopInterest } from "@/lib/interests";
import { IMG } from "@/lib/images";

// "Recommandé pour vous" — light personalization based on what the visitor has consulted.
export default function Recommended() {
  const { data: books = [] } = useQuery({ queryKey: ["books"], queryFn: () => getList("books") });
  const top = getTopInterest();

  const book = useMemo(() => {
    if (!books.length) return null;
    if (top) {
      const match = books.find((b) => (b.genre || "").toLowerCase() === top.toLowerCase());
      if (match) return match;
    }
    return books[Math.floor(Math.random() * books.length)];
  }, [books, top]);

  if (!book) return null;

  return (
    <section className="dl-container py-16" data-testid="recommended-section">
      <div className="flex items-center gap-2 mb-8">
        <Sparkles size={16} className="text-[#C6A76A]" />
        <div className="dl-eyebrow">Recommandé pour vous</div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Link to={`/livres/${book.slug}`} className="dl-card p-6 flex gap-5 group">
          <div className="w-20 shrink-0 aspect-[2/3] bg-[#141A2E] border border-[rgba(198,167,106,0.25)] overflow-hidden flex items-center justify-center">
            {book.cover_url ? <img src={book.cover_url} alt={book.title} className="w-full h-full object-cover" /> : <span className="serif text-[0.65rem] text-[#F3E9D2]/60 text-center px-1">{book.title}</span>}
          </div>
          <div>
            <div className="dl-eyebrow" style={{ fontSize: "0.55rem" }}>Un livre</div>
            <div className="serif text-lg text-[#F3E9D2] mt-1 group-hover:text-[#D4B978]">{book.title}</div>
            {book.genre && <div className="text-xs text-[#F3E9D2]/50 mt-1">{book.genre}</div>}
          </div>
        </Link>

        <Link to="/les-chroniques-de-letrange" className="dl-card p-6 relative overflow-hidden group flex flex-col justify-between">
          <img src={IMG.gothic} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20 group-hover:opacity-30 transition-opacity" />
          <div className="relative z-10">
            <div className="dl-eyebrow" style={{ fontSize: "0.55rem" }}>Une chronique</div>
            <div className="serif text-lg text-[#F3E9D2] mt-1">Les Chroniques de l'Étrange</div>
          </div>
          <span className="relative z-10 text-[#D4B978] text-sm inline-flex items-center gap-1 mt-4">Explorer <ArrowRight size={14} /></span>
        </Link>

        <Link to="/conferences" className="dl-card p-6 relative overflow-hidden group flex flex-col justify-between">
          <img src={IMG.conference1} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20 group-hover:opacity-30 transition-opacity" />
          <div className="relative z-10">
            <div className="dl-eyebrow" style={{ fontSize: "0.55rem" }}>Une conférence</div>
            <div className="serif text-lg text-[#F3E9D2] mt-1">Conférences & interventions</div>
          </div>
          <span className="relative z-10 text-[#D4B978] text-sm inline-flex items-center gap-1 mt-4">Voir les thèmes <ArrowRight size={14} /></span>
        </Link>
      </div>
    </section>
  );
}
